import { storeToRefs } from 'pinia';
import { clientEmailStore } from '~/stores/clientEmail';


export default function () {

  const store = clientEmailStore();
  const { clientEmail } = storeToRefs(store);

  const { cart } = useCartExtended();

  const customerEmailFromCart = computed(() => cart.value?.customerEmail);

  const setClientEmail = (email: string) => {

    store.setClientEmail(email);
  
  };

  watch(() => customerEmailFromCart.value, (customerEmail) => {

    if (!clientEmail.value && customerEmail) {

      setClientEmail(customerEmail);
    
    }
  
  }, { immediate: true });

  return {
    ...store,
    clientEmail,

    setClientEmail,
  };

}